<template>
  <div id="app">
    <div class="content">
      <my-header />
      <router-view/>
    </div>
    <my-footer class="footer" />
  </div>
</template>

<script>
import MyHeader from '@/components/Header.vue';
import MyFooter from '@/components/Footer.vue';

export default {
  components: {
    MyHeader,
    MyFooter,
  },
};
</script>

<style lang="scss">
html, body {
  margin: 0;
  padding: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>

<style lang="scss" scoped>
#app {
  min-height: 100vh;
  position: relative;
  .content {
    padding-bottom: 200px;
  }
  .footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 200px;
  }
}
</style>
